import { requestGet } from '@/common/request';

export interface listAdminParams {
  name?: string;
  organizationName?: string;
}

export interface listAdminRes {
  ret: string;
  msg: string;
  data: ChannelList[];
}

export interface ChannelList {
  id: number;
  channelId: string;
  name: string;
  pic: string;
  order: number;
  remark: string;
  linkType: number;
  link: string;
  online: number;
  channelLevel: number;
  childChannelCount: number;
  channelType: number;
  childChannelList?: ChannelList;
  towerIds: string;
  organizationName: string;
  channelTag: string;
}

export async function listAdmin(params?: listAdminParams): Promise<listAdminRes> {
  return await requestGet('/channelActivity/listAdmin', params);
}
